/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Toggle_Annual_LabelInputs */

const en_pricing_toggle_annual_label = /** @type {(inputs: Pricing_Toggle_Annual_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle annual billing`)
};

const de_pricing_toggle_annual_label = /** @type {(inputs: Pricing_Toggle_Annual_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährliche Abrechnung umschalten`)
};

const fr_pricing_toggle_annual_label = /** @type {(inputs: Pricing_Toggle_Annual_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer la facturation annuelle`)
};

const es_pricing_toggle_annual_label = /** @type {(inputs: Pricing_Toggle_Annual_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar facturación anual`)
};

const it_pricing_toggle_annual_label = /** @type {(inputs: Pricing_Toggle_Annual_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva la fatturazione annuale`)
};

const nl_pricing_toggle_annual_label = /** @type {(inputs: Pricing_Toggle_Annual_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schakel jaarlijkse facturering`)
};

const pl_pricing_toggle_annual_label = /** @type {(inputs: Pricing_Toggle_Annual_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przełącz rozliczanie roczne`)
};

const fi_pricing_toggle_annual_label = /** @type {(inputs: Pricing_Toggle_Annual_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaihda vuosittainen lasku`)
};

const da_pricing_toggle_annual_label = /** @type {(inputs: Pricing_Toggle_Annual_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skift til årlig fakturering`)
};

const sv_pricing_toggle_annual_label = /** @type {(inputs: Pricing_Toggle_Annual_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Växla årsfakturering`)
};

/**
* | output |
* | --- |
* | "Toggle annual billing" |
*
* @param {Pricing_Toggle_Annual_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_toggle_annual_label = /** @type {((inputs?: Pricing_Toggle_Annual_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Toggle_Annual_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_toggle_annual_label(inputs)
	if (locale === "fr") return fr_pricing_toggle_annual_label(inputs)
	if (locale === "es") return es_pricing_toggle_annual_label(inputs)
	if (locale === "it") return it_pricing_toggle_annual_label(inputs)
	if (locale === "nl") return nl_pricing_toggle_annual_label(inputs)
	if (locale === "pl") return pl_pricing_toggle_annual_label(inputs)
	if (locale === "fi") return fi_pricing_toggle_annual_label(inputs)
	if (locale === "da") return da_pricing_toggle_annual_label(inputs)
	if (locale === "sv") return sv_pricing_toggle_annual_label(inputs)
	return en_pricing_toggle_annual_label(inputs)
});